import { collection, doc, getDocs, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import { TABLES } from "../enums/tables";

export const getSuggestions = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, TABLES.SUGGESTED_CATEGORIES));
    return querySnapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
  } catch (error) {
    console.error("Error getting suggestions:", error);
    return [];
  }
};

export const updateStatus = async (id, status) => {
  const docRef = doc(db, TABLES.SUGGESTED_CATEGORIES, id);
  await updateDoc(docRef, { status });
};

export const remove = async (id) => {
  const docRef = doc(db, TABLES.SUGGESTED_CATEGORIES, id);
  await deleteDoc(docRef);
};
